/**
 * Toolbar — a horizontal row for filters/segmented controls and right-aligned
 * actions. Used above tables (queue filters, role selectors, Refresh).
 */
import type { CSSProperties, ReactNode } from 'react';

export interface ToolbarProps {
  /** Left-aligned content (filters, selectors). */
  children?: ReactNode;
  /** Right-aligned content (buttons). */
  actions?: ReactNode;
  style?: CSSProperties;
}

export function Toolbar({ children, actions, style }: ToolbarProps) {
  return (
    <div style={{ ...wrap, ...style }}>
      <div style={left}>{children}</div>
      {actions && <div style={right}>{actions}</div>}
    </div>
  );
}

const wrap: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12,
  flexWrap: 'wrap',
};
const left: CSSProperties = { display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' };
const right: CSSProperties = { display: 'flex', alignItems: 'center', gap: 8 };
